import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiIconButton: {
            defaultProps: {
                disableFocusRipple: true,
                disableRipple: true,
                disableTouchRipple: true
            }
        }
    }
})


export default theme;